import { Box, Grid } from '@factorialco/deprecated-design-system'
import { PurchaseRequestFragment } from 'generated/resources/graphql'

import { contactFullName } from 'modules/finance/lib/contactsUtils'
import InfoItem from 'modules/procurement/components/InfoItem'

interface Props {
  purchaseRequest: PurchaseRequestFragment
}

const AdditionalInfo = ({ purchaseRequest }: Props) => {
  const answers = purchaseRequest?.formsMembership?.answers || []

  const getAnswerLabel = (answer: (typeof answers)[number]) => {
    if (!answer.element?.options || !answer.answer) {
      return answer.answer
    }

    // If there are no options, it's a text field or dataset-backed dropdown
    if (answer.element.options.length === 0) {
      // For vendor dataset fields, resolve the ID to the vendor name
      if (
        answer.element.params?.dataset === 'vendor' &&
        purchaseRequest.vendor &&
        answer.answer === String(purchaseRequest.vendor.id)
      ) {
        return contactFullName(purchaseRequest.vendor)
      }
      return answer.answer
    }

    // Check if answer contains comma-separated values (multiple choice)
    if (answer.answer.includes(',')) {
      const selectedOptionIds = answer.answer.split(',')
      const selectedLabels = selectedOptionIds
        .map((optionId) => {
          const option = answer.element?.options.find((opt) => opt.id === optionId.trim())
          return option?.label
        })
        .filter(Boolean) // Remove undefined values

      return selectedLabels.join(', ')
    }

    // Single choice answer
    const selectedOption = answer.element.options.find((option) => option.id === answer.answer)
    return selectedOption?.label ?? answer.answer
  }

  if (answers.length === 0) {
    return null
  }

  // Filter out answers that don't have valid labels or text
  const validAnswers = answers.filter((answer) => {
    const label = answer.element?.label
    const answerText = getAnswerLabel(answer)
    return label && answerText
  })

  if (validAnswers.length === 0) {
    return null
  }

  return (
    <Box gap="s2">
      <Grid variant="fixed">
        {validAnswers.map((answer) => {
          const label = answer.element?.label
          const answerText = getAnswerLabel(answer)

          if (!label || !answerText) return null

          return (
            <Box key={answer.id} gridColSpan={{ xxs: 12 }}>
              <InfoItem label={label} textItem={answerText} />
            </Box>
          )
        })}
      </Grid>
    </Box>
  )
}

export default AdditionalInfo
